import React, { useContext } from 'react'
import {
  LegalContent,
  IProps as ILegalContent,
} from 'marketing-site/src/library/components/LegalContent'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { ILegalContent as IContentfulLegalContent } from 'marketing-site/@types/generated/contentful'
import { transformSecondaryNav } from './ContentfulSecondaryNav'
import { transformLegalSection } from './ContentfulLegalSection'
import CurrentLocaleContext from 'marketing-site/src/components/context/CurrentLocaleContext'
import { Locale } from 'contentful'

export const ContentfulLegalContent = (
  legalPageWrapper: IContentfulLegalContent,
): React.ReactElement => {
  const currentLocale = useContext(CurrentLocaleContext)
  return (
    <EntryMarker entry={legalPageWrapper}>
      {() => <LegalContent {...transformLegalContent(legalPageWrapper, currentLocale)} />}
    </EntryMarker>
  )
}

export function transformLegalContent(
  { fields }: IContentfulLegalContent,
  locale: Locale,
): ILegalContent {
  return {
    ...fields,
    content: transformLegalSection(fields.content),
    navigation: transformSecondaryNav(fields.navigation, locale),
  }
}
